import React from 'react';

const RetiredBankerBottomline = () => {
  const benefits = [
    {
      title: "Pension-Optimized Asset Allocation",
      description: "Strategic financial planning helps create an investment strategy that complements your defined benefit pension, balancing security with sufficient growth to protect against inflation throughout retirement."
    },
    {
      title: "Tax-Efficient Income Structuring",
      description: "A comprehensive approach organizes retirement income streams from pension, interest, dividends and other sources to minimize tax burden while maintaining consistent monthly cash flow."
    },
    {
      title: "Healthcare Security Enhancement",
      description: "Custom planning builds on existing bank retirement medical benefits with additional layers of protection to ensure quality healthcare access without financial stress in later years."
    },
    {
      title: "Legacy and Succession Planning",
      description: "Professional guidance helps transform pension terminal benefits and accumulated wealth into meaningful legacies for family, causes, and institutions that matter most to you."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Bank Retiree Financial Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RetiredBankerBottomline;